export const AcademyTypeDecorator = {
  url() {
    return `signup-hubspot/academy`;
  },

  query() {
    return {};
  }

};